import {
  getBorderRadius,
  getBorderWidth,
} from '@/components/Dropdown/Dropdown.styles';
import { styled } from '@mui/system';
import { IStyledLIProps, IStyledProps } from './Types';

export const UL = styled('ul')<IStyledProps>`
  height: auto;
  display: flex;
  flex-direction: column;
  border: ${({ expanded }) => (expanded ? 1 : 0)}px solid #dedede;
  border-top-width: ${getBorderWidth('top-start')};
  border-bottom-width: ${getBorderWidth('bottom-start')};
  background: #fff;
  max-height: ${({ maxHeight }) => maxHeight}px;
  border-top-left-radius: ${getBorderRadius('bottom-start')}rem;
  border-top-right-radius: ${getBorderRadius('bottom-start')}rem;
  border-bottom-left-radius: ${getBorderRadius('top-start')}rem;
  border-bottom-right-radius: ${getBorderRadius('top-start')}rem;
  overflow: auto;
`;
export const DropdownButton = styled('button')<IStyledProps>`
  width: 100%;
  height: 2.625rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  color: #7d7d7d;
  border-top-left-radius: ${getBorderRadius('top-start')}rem;
  border-top-right-radius: ${getBorderRadius('top-start')}rem;
  border-bottom-left-radius: ${getBorderRadius('bottom-start')}rem;
  border-bottom-right-radius: ${getBorderRadius('bottom-start')}rem;
  transition: all 0.2s ${({ expanded }) => (expanded ? 0 : '0.1s')};
  border: 1px solid #dedede;
  border-bottom-width: ${getBorderWidth('top-start')}px;
  border-top-width: ${getBorderWidth('bottom-start')}px;
  font-size: 0.875rem;
  background-color: #fff;
  gap: 0.625rem;
  &:focus {
    outline: none;
  }
  @media screen and (min-width: 640px) {
    font-size: 1rem;
    height: 3.123rem;
    gap: 2.25rem;
  }
`;
export const OptionLabel = styled('div')`
  border-top: 1px solid ${({ theme }) => theme.palette.grey[200]};
  margin: 0 1.25rem;
  min-height: 2.625rem;
  display: flex;
  align-items: center;
`;
export const LI = styled('li')<IStyledLIProps>`
  color: ${({ $selected }) => ($selected ? '#5FA3A9' : '#7D7D7D')};
  font-size: 0.875rem;
  cursor: pointer;
  &:hover {
    color: #5fa3a9;
    background-color: #5fa3a950;
  }
  &:first-of-type {
    ${OptionLabel} {
      border-top: ${({ placement }) =>
        placement === 'bottom-start' ? '1px solid #dedede' : 0};
    }
  }
  &:last-of-type {
    ${OptionLabel} {
      border-bottom: ${({ placement }) =>
        placement === 'top-start' ? '1px solid #dedede' : 0};
    }
  }
  @media screen and (min-width: 640px) {
    height: 3 125rem;
    font-size: 1rem;
  }
`;

export const Wrapper = styled('div')``;

export const Label = styled('div')`
  letter-spacing: 0.2px;
  color: #000;
  margin-bottom: 0.625rem;
  font-size: 0.875rem;
  line-height: 0.875rem;
  padding-left: 1.25rem;
  @media screen and (min-width: 640px) {
    font-size: 1rem;
    line-height: 1rem;
    padding-left: 0;
  }
`;

export const SelectedValue = styled('div')`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
